<template>
    <table-simple-value :value="date" />
</template>

<script>
import TableSimpleValue from './TableSimpleValue.vue';
import Utils from '../utils';

export default {
    name: 'TableDateValue',
    components: { TableSimpleValue },
    props: ['value'],
    computed: {
        date() {
            const value = this.value;
            if (value == null) {
                return '';
            }
            const date = value.value || value;
            const str = Utils.dateTimeToString(date);
            return {
                value: str,
                icon: value.icon,
                action: value.action,
                actions: value.actions,
            };
        },
    },
};
</script>

<style scoped>
</style>
